import React from 'react';
import { IconBubbleText, IconMessageCircle } from '@tabler/icons-react';
import styles from './MDocumentCard.module.css';

import MOptionsMenu from './MOptionsMenu';

interface HealthMemoryCardProps {
  title: string;
  year?: number;
  onClick?: () => void;
  optionsMenu?: Array<{
    id: string;
    label: string;
    icon: React.ReactNode;
    onClick: () => void;
    className?: string;
  }>;
}

const HealthMemoryCard: React.FC<HealthMemoryCardProps> = ({ title, year, onClick, optionsMenu }) => {
  return (
    <div
      className={styles.card}
      tabIndex={onClick ? 0 : undefined}
      role={onClick ? 'button' : undefined}
      onClick={onClick}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
      style={{ cursor: onClick ? 'pointer' : undefined, position: 'relative', marginBottom: 3 }}
    >
      <div className={styles.cardContent}>
        {/* Document Title */}
        <div className={styles.title}>
          {title}
        </div>
        
        {/* Category and Date Row */}
        <div className={styles.categoryDateRow}>
          <div className={styles.categoryInfo}>
            <div className={styles.categoryIcon}>
              <IconBubbleText size={20} />
            </div>
            <span className={styles.categoryName}>Health Memory</span>
          </div>
          <div className={styles.dateInfo}>
            {year ? <span className={styles.dateText}>{`In ${year}`}</span> : null}
          </div>
        </div>
      </div>
      
      {/* Options Menu */}
      {optionsMenu && optionsMenu.length > 0 && (
        <div className={styles.optionsMenu}>
          <MOptionsMenu options={optionsMenu.map(opt => ({
            ...opt,
            icon: opt.icon || <span style={{ width: 20, display: 'inline-block' }} />
          }))} />
        </div>
      )}
    </div>
  );
};

export default HealthMemoryCard;
